import { ResetPasswordFormValues } from "@/components/auth/reset-password-form";
import { SignUpFormValues } from "@/components/auth/sign-up-form";
import { baseApiUrl, HttpRes } from "@/http/config";
import { User } from "@/types/user";

function userLogin(username: string, password: string): Promise<User> {
  console.log("user login called");
  // return Promise.resolve({
  //   id: "mock-user-id-1",
  //   username: "MOCK USER NAME",
  //   token: "12345",
  // });
  const payload = {
    user_login: {
      username,
      password,
    },
  };
  return fetch(baseApiUrl + "/user/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((res: HttpRes<User>) => {
      return processResponse(res);
    });
}

function postOauthToken(token: string, source: string) {
  console.log("postOauthToken called");
  const payload = {
    token,
    source,
  };
  return fetch(baseApiUrl + "/user/oauth_login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      return res.json();
    })
    .then((res: HttpRes<User>) => {
      return processResponse(res);
    });
}

function userRegister({ password, email, code }: SignUpFormValues) {
  const payload = {
    user: {
      username: email, // 当前简化流程，使用邮箱
      password,
      email,
      register_code: code,
    },
  };
  return fetch(baseApiUrl + "/user/register", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((res) => {
      console.log("user register:", res.result);
      return res.result;
    });
}

function sendEmailVerifyCode(email: string) {
  const payload = {
    user: {
      email,
    },
  };
  return fetch(baseApiUrl + "/user/send_code", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((res) => {
      return res.result;
    });
}

function forgotPassword(email: string) {
  const payload = {
    user: {
      email,
    },
  };
  return fetch(baseApiUrl + "/user/forgot_password", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((res) => {
      return res.result;
    });
}

function resetPassword({ email, password, code }: ResetPasswordFormValues) {
  const payload = {
    user: {
      email,
      password,
      code,
    },
  };
  return fetch(baseApiUrl + "/user/reset_password", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((res) => {
      return res.result;
    });
}

function processResponse(res: HttpRes<unknown>) {
  if (res.code === 200) {
    return Promise.resolve(res.result);
  } else {
    console.error(`Received non-200 code`, res);
    return Promise.reject(res.message);
  }
}

export {
  userLogin,
  userRegister,
  sendEmailVerifyCode,
  forgotPassword,
  resetPassword,
  postOauthToken,
};
